exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2T-pjkP6e1jl2Fr3yjd-SS{display:inline;width:70%}html[dir=ltr] ._2T-pjkP6e1jl2Fr3yjd-SS{float:left}html[dir=rtl] ._2T-pjkP6e1jl2Fr3yjd-SS{float:right}._3UfG0EMOxSWzPxfN1n5-lS{display:inline}html[dir=ltr] ._3UfG0EMOxSWzPxfN1n5-lS{float:right}html[dir=rtl] ._3UfG0EMOxSWzPxfN1n5-lS{float:left}", ""]);

// exports
exports.locals = {
	"subscription_text_container": "_2T-pjkP6e1jl2Fr3yjd-SS",
	"subscription_btn_container": "_3UfG0EMOxSWzPxfN1n5-lS"
};